import React, { useCallback } from "react";
import { Modal } from "react-responsive-modal";
import { AlertTriangle } from "lucide-react";

export default function ConfirmModal({
  open,
  onClose,
  onAfterClose,
  onConfirm,
  title,
  message,
  highlight,
  highlightClassName = "",
  highlightWrapperClassName = "",
  confirmLabel = "Confirm",
  confirmLoadingLabel = "Working...",
  confirmDisabled = false,
  isConfirming = false,
  cancelLabel = "Cancel",
  modalClassName = "internal-modal-base internal-modal--narrow",
  bodyClassName = "",
  messageClassName = "internal-confirm__text",
  Icon = AlertTriangle,
  closeIcon = true,
  confirmVariant = "primary",
}) {
  const handleAnimationEnd = useCallback(() => {
    if (!open) {
      onAfterClose?.();
    }
  }, [open, onAfterClose]);

  const resolvedVariant =
    confirmVariant === "danger" ? "danger" : "primary";

  return (
    <Modal
      open={open}
      onClose={onClose}
      onAnimationEnd={handleAnimationEnd}
      center
      classNames={{ modal: modalClassName }}
      focusTrapped
      closeIcon={closeIcon}
    >
      <div
        className={`internal-modal-shell internal-confirm internal-confirm--centered ${bodyClassName}`.trim()}
      >
        <div className="internal-confirm__content">
          <span className="internal-modal__icon internal-confirm__icon">
            <Icon aria-hidden="true" />
          </span>
          <h2 className="internal-modal__title internal-confirm__title">
            {title}
          </h2>
          {highlight ? (
            <div
              className={`internal-confirm__highlight-wrapper ${highlightWrapperClassName}`.trim()}
            >
              <span className={`internal-confirm__highlight ${highlightClassName}`.trim()}>
                {highlight}
              </span>
            </div>
          ) : null}
          {message ? <div className={messageClassName}>{message}</div> : null}
        </div>
        <div className="internal-modal__actions internal-confirm__actions">
          <button
            className="internal-button internal-button--secondary"
            type="button"
            onClick={onClose}
          >
            {cancelLabel}
          </button>
          <button
            className={`internal-button internal-button--${resolvedVariant}`}
            type="button"
            onClick={onConfirm}
            disabled={confirmDisabled || isConfirming}
          >
            {isConfirming ? confirmLoadingLabel : confirmLabel}
          </button>
        </div>
      </div>
    </Modal>
  );
}
